export default "/images/73b52579e8e08173a2eea06bce1ee5d4.png";